import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { get, isString } from 'lodash';
import {
  applyPastFilters,
  resetPastFilters,
  updateBulkPastFilters,
  updatePastFilters,
} from 'redux/ducks/Event';
import { getAthleticTrainers } from 'redux/ducks/User';
import { sportsFilter } from '../../helpers/enums';
import CollapsibleFilterPanel from 'components/CollapsibleFilterPanel';
import InputOrFlatpickr from 'components/InputOrFlatpickr';
import moment from 'moment';

export class FinanceFiltersPanel extends Component {

  constructor(props) {
    super(props);

    this.state = {
      filters: {
        past: true,
      }
    }

    this.props.getAthleticTrainers();
  }

  componentWillMount() {
    this.setState({
      ...this.state,
      filters: {
        ...this.props.filters
      },
    })
  }
  componentDidUpdate() {
    if (this.props.filters.reset) {
      this.setState({
        ...this.state,
        filters: {
          ...this.props.filters
        }
      });
      this.props.updateFilter('reset', false);
    }
  }

  inputColor = (field) => {
    return this.props.filters[field] ? 'selected' : 'blank';
  };

  onFieldChange = (field, event) => {
    if (!isString(event)) event.preventDefault();

    const value = isString(event) ? event : get(event, 'target.value');
    this.setState({
      ...this.state,
      filters: {
        ...this.state.filters,
        [field]: value
      }
    })
  };

  onReset = () => {
    this.props.reset({ past: true });
  };

  onSubmit = () => {
    this.props.updateFilters(this.state.filters)
    this.props.submit();
  }

  render() {
    return (
      <div className="eventFiltersPanel">
        <CollapsibleFilterPanel title='Event Filters'
          onCancel={this.onReset}
          applyFilters={this.props.applyFilters}
          onSubmit={this.onSubmit}>
          <div className='form-group search-group'>
            <i className='fa fa-search' />
            <input className='form-control'
              placeholder='SEARCH EVENT NAME'
              onChange={event => this.onFieldChange('title', event)}
              value={this.state.filters.title} />
          </div>
          <div className='form-group'>
            <label>Event Code</label>
            <input className='form-control'
              placeholder='Enter Event Code'
              onChange={event => this.onFieldChange('eventCode', event)}
              value={this.state.filters.eventCode} />
          </div>
          <div className='form-group'>
            <label>Job Start Date</label>
            <InputOrFlatpickr className={classnames('form-control picker', this.inputColor('startDate'))}
              placeholder="mm/dd/yyyy"
              onChange={event => this.onFieldChange('startDate', event)}
              value={this.state.filters.startDate}
              type='text'
              options={{
                maxDate: moment().toDate(),
              }}
              />
          </div>
          <div className='form-group'>
            <label>Job End Date</label>
            <InputOrFlatpickr className={classnames('form-control picker', this.inputColor('endDate'))}
              placeholder="mm/dd/yyyy"
              onChange={event => this.onFieldChange('endDate', event)}
              value={this.state.filters.endDate}
              type='text'
              options={{
                maxDate: moment().toDate(),
              }}
            />
          </div>
          <div className='form-group'>
            <label>Payment Succeeded Date</label>
            <InputOrFlatpickr className={classnames('form-control picker', this.inputColor('stripePaidAt'))}
              placeholder='Select Payment Succeeded Date'
              onChange={event => this.onFieldChange('stripePaidAt', event)}
              value={this.state.filters.stripePaidAt}
              type='date' />
          </div>
          <div className='form-group'>
            <label>Total Payment</label>
            <input className='form-control'
              type="number"
              step="0.01"
              onChange={event => this.onFieldChange('eoTotalCharge', event)}
              value={this.state.filters.eoTotalCharge} />
          </div>
          <div className='form-group'>
            <label>Healthcare Professional</label>
            <select className={classnames('form-control', 'custom-select', this.inputColor('healthcareProfessional'))}
              onChange={event => this.onFieldChange('healthcareProfessional', event)}
              value={this.state.filters.healthcareProfessional}>
              <option value='' disabled hidden>Select Option</option>
              <option value=''></option>
              {this.props.athleticTrainers.map((trainer) => {
                return <option value={trainer.id} key={trainer.id}>{trainer.name}</option>
              })}
            </select>
          </div>
          <div className='form-group'>
            <label>Setting</label>
            <select className={classnames('form-control', 'custom-select', this.inputColor('eventSetting'))}
              onChange={event => this.onFieldChange('eventSetting', event)}
              value={this.state.filters.eventSetting}>
              <option value='' disabled hidden>Select Option</option>
              {optionsForEnum(this.props.eventSettings)}
            </select>
          </div>
          <div className='form-group'>
            <label>Setting Detail</label>
            <select className={classnames('form-control', 'custom-select', this.inputColor('settingDetail'))}
              onChange={event => this.onFieldChange('settingDetail', event)}
              value={this.state.filters.settingDetail}>
              <option value='' disabled hidden>Select Option</option>
              {optionsForEnum(this.props.settingDetails)}
            </select>
          </div>
          <div className='form-group'>
            <label>Sport</label>
            <select className={classnames('form-control', 'custom-select', this.inputColor('sport'))}
              onChange={event => this.onFieldChange('sport', event)}
              value={this.state.filters.sport}>
              <option value='' disabled hidden>Select Option</option>
              {optionsForEnum(sportsFilter(this.props.sports))}
            </select>
          </div>
          {/* TODO: These filters reset themselves after filters apply. We need
            * a new API to get all HCPs that ever worked for you. See this vide
            * for more information https://vimeo.com/667923098.
            */}
        </CollapsibleFilterPanel>
      </div>
    );
  }
}

function optionsForEnum(enum_vals) {
  return [<option value="" key=''></option>].concat(enum_vals.map(e => <option value={e.id} key={e.name}>{e.name}</option>))
}

function mapStateToProps(state) {
  const {
    eventSettings,
    settingDetails,
    sports,
  } = state.enums;
  return {
    athleticTrainers: state.user.athleticTrainers,
    filters: state.event.filters.past,
    eventSettings,
    settingDetails,
    sports,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAthleticTrainers: () => dispatch(getAthleticTrainers()),
    reset: () => dispatch(resetPastFilters()),
    submit: () => dispatch(applyPastFilters()),
    updateFilter: (filter, value) => dispatch(updatePastFilters(filter, value)),
    updateFilters: (filters) => dispatch(updateBulkPastFilters(filters)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FinanceFiltersPanel);